import L from 'leaflet'
import { Marker, MarkerProps } from 'react-leaflet'

interface Props {
  color: string
  coordAlert: boolean
}
const MountpointMarker = ({ coordAlert, color, children, ...rest }: Props & MarkerProps) => {
  const getIcon = () => {
    return `<svg xmlns="http://www.w3.org/2000/svg" height="47px" viewBox="0 -960 960 960" width="47px" fill=${color}><path d="M480-80 374-240H140q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H586L480-80Z"/></svg>`
  }

  const customIcon = L.divIcon({
    className: 'custom-div-icon',
    // html: `${getIcon()}`,
    html: `<div class=${
      coordAlert ? 'pulsy-mountpoint-marker' : 'mountpoint-marker'
    }>${getIcon()}</div>`,
    iconAnchor: [-11.88, 45],
    tooltipAnchor: [40, -10],
  })

  return (
    <Marker {...rest} icon={customIcon}>
      {children}
    </Marker>
  )
}

export default MountpointMarker
